import { AIRPORT_FROM, AIRPORT_TO } from 'components/utils/airportTypes';
import merge from 'lodash/merge';

const AIRPORT_NAME = "torp";
const AIRPORT_NAME_OSLO = "oslo torp";

class RevertAirportHelper {
  constructor(props, clickedAirport, airportType) {
    this.props = props;
    this.airportType = airportType;
    this.departureAirport = this.clone(props.airportFrom);
    this.returnAirport = this.clone(props.airportTo);
    this.previousAirport = null;
    this.newAirport = {
      airportType: airportType,
      id: clickedAirport.id,
      label: clickedAirport.name,
      isAirport: clickedAirport.is_airport ? true : false,
      code: clickedAirport.code
    }
  }

  getAirportObject() {
    return this.newAirport;
  }

  clone(obj) {
    return merge({}, obj);
  }

}

export default RevertAirportHelper;
